<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.digital-wallet") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row no-gutters>
        <v-col cols="12" class="mb-4">
          <BaseSelect
            :label="$t('events.event-config.withdrawal-settings')"
            :placeholder="$t('events.event-config.withdrawal-settings')"
            item-text="text"
            return-object
            small-chips
            item-color="tertiary"
            :clearable="false"
            :items="withdrawSettings"
            v-model="selectedWithdraw"
          />
        </v-col>

        <v-col cols="12">
          <BaseTextField
            :label="$t('events.event-config.released-balance')"
            min="0"
            max="100"
            type="number"
            :placeholder="$t('events.event-config.insert-released-balance')"
            v-model.number="freeBalance"
            suffix="%"
            :input="formatError()"
            :error-messages="balanceError"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "PaymentSettings",
  components: {
    BaseSelect,
    BaseTextField,
  },
  data: () => ({
    selectedWithdraw: {
      text: "Pós evento (D+2)",
      value: { tipo: "pos", dias: "2" },
    },
    freeBalance: 80,
    balanceError: "",
  }),
  computed: {
    ...mapGetters(["digitalWallet"]),
    withdrawSettings() {
      return [
        {
          text: this.$t("events.event-config.post-event-d2"),
          value: { tipo: "pos", dias: "2" },
        },
        {
          text: this.$t("events.event-config.pre-event-d2"),
          value: { tipo: "pre", dias: "2" },
        },
        {
          text: this.$t("events.event-config.pre-event-d30"),
          value: { tipo: "pre", dias: "30" },
        },
        {
          text: this.$t("events.event-config.pre-event-weekly"),
          value: { tipo: "semanal", dias: "1" },
        },
      ];
    },
  },
  methods: {
    ...mapMutations(["setDigitalWallet"]),
    formatError() {
      if (this.freeBalance <= 0 || this.freeBalance > 100) {
        this.balanceError = this.$t("events.event-config.balance-error");
      } else {
        this.balanceError = "";
      }
      return "";
    },
    updateDigitalWallet() {
      const { tipo, dias } = this.selectedWithdraw.value;
      const limite = this.freeBalance;

      this.setDigitalWallet([
        {
          ...this.digitalWallet[0],
          tipo,
          dias,
          limite,
          saque: "manual",
        },
      ]);
    },
  },
  watch: {
    selectedWithdraw() {
      this.updateDigitalWallet();
    },
    freeBalance() {
      this.updateDigitalWallet();
    },
  },
  mounted() {
    if (this.$produtos_gerenciar.produtosAddEdit == "new") {
      this.updateDigitalWallet();
    }
    if (this.digitalWallet[0].dias > 0) {
      this.selectedWithdraw = this.withdrawSettings.find(
        item =>
          item.value.tipo === this.digitalWallet[0].tipo &&
          item.value.dias === this.digitalWallet[0].dias
      );
      this.freeBalance = this.digitalWallet[0].limite;
    }
  },
};
</script>

<style scoped></style>
